import { DEFAULT_RATE_CONFIG } from '@zg/shared';
import type { Deductibles } from '@zg/shared';
import { FieldGrid } from '../form/FieldGrid';
import { Select } from '../form/Select';
import type { UseIndicationFormResult } from '../../hooks/useIndicationForm';
import { formatCurrency } from '../../lib/format';

interface Props {
  form: UseIndicationFormResult;
}

type DeductibleKey = keyof Deductibles;

function opts(values: readonly number[]) {
  return values.map((v) => ({ value: String(v), label: formatCurrency(v) }));
}

const fields: { key: DeductibleKey; label: string; values: readonly number[] }[] = [
  {
    key: 'brAop',
    label: 'BR AOP Deductible',
    values: DEFAULT_RATE_CONFIG.deductibleOptions.brAop,
  },
  {
    key: 'brFlood',
    label: 'BR Flood Deductible',
    values: DEFAULT_RATE_CONFIG.deductibleOptions.brFlood,
  },
  {
    key: 'brWaterDamage',
    label: 'BR Water Damage Deductible',
    values: DEFAULT_RATE_CONFIG.deductibleOptions.brWaterDamage,
  },
  {
    key: 'oiGl',
    label: 'OI GL Deductible',
    values: DEFAULT_RATE_CONFIG.deductibleOptions.oiGl,
  },
  {
    key: 'pollution',
    label: 'Pollution Deductible',
    values: DEFAULT_RATE_CONFIG.deductibleOptions.pollution,
  },
];

export function StepDeductibles({ form }: Props) {
  const { state, setDeductible, markTouched, errors } = form;

  return (
    <fieldset className="border-0 p-0 m-0">
      <legend className="sr-only">Deductibles</legend>
      <FieldGrid>
        {fields.map((f) => {
          const errorKey = `deductibles.${f.key}`;
          return (
            <div key={f.key} data-field={errorKey}>
              <Select
                label={f.label}
                required
                options={opts(f.values)}
                value={String(state.deductibles[f.key])}
                onChange={(e) => setDeductible(f.key, Number(e.target.value))}
                onBlur={() => markTouched(errorKey)}
                error={errors[errorKey]}
              />
            </div>
          );
        })}
      </FieldGrid>
    </fieldset>
  );
}
